// valquimistas.js

function initValquimistasSlider(root) {
  if (!root) return;

  var track = root.querySelector('.valquimistas_slider-track');
  if (!track) return;

  // Evitar inicializar dos veces
  if (track.dataset.flickityInit === 'true') return;
  if (typeof Flickity === 'undefined') return;

  new Flickity(track, {
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    adaptiveHeight: true
  });

  track.dataset.flickityInit = 'true';
}

// Cuando carga la página
document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.valquimistas_slider');
  sliders.forEach(function (slider) {
    initValquimistasSlider(slider);
  });
});

// Para el editor de temas de Shopify (cuando se recarga la sección)
document.addEventListener('shopify:section:load', function (event) {
  var section = event.target;
  var sliders = section.querySelectorAll('.valquimistas_slider');
  sliders.forEach(function (slider) {
    initValquimistasSlider(slider);
  });
});
